import { render, staticRenderFns } from "./CourseSwiper.vue?vue&type=template&id=49a05a17&scoped=true&"
import script from "./CourseSwiper.vue?vue&type=script&lang=js&"
export * from "./CourseSwiper.vue?vue&type=script&lang=js&"
import style0 from "./CourseSwiper.vue?vue&type=style&index=0&id=49a05a17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a05a17",
  null
  
)

export default component.exports